export enum ERouterTabNames {
  users = 'users',
  roles = 'roles',
}
